import { API } from 'aws-amplify';
import { requestWrapper } from '../../services/api/P3ApiService';

const P3_API_NAME = 'P3ApiProxy';

function get(path) {
  return requestWrapper((options) => API.get(P3_API_NAME, `/${path}`, options));
}

function post(path, body) {
  return requestWrapper((options) => {
    // set the body
    Object.assign(options, { body });
    // make request
    return API.post(P3_API_NAME, `/${path}`, options);
  });
}

function patch(path, body) {
  return requestWrapper((options) => {
    // set the body
    Object.assign(options, { body });
    // make request
    return API.patch(P3_API_NAME, `/${path}`, options);
  });
}

function del(path) {
  return requestWrapper((options) => API.del(P3_API_NAME, `/${path}`, options));
}

export { get, post, patch, del };
